import { __mathop } from "../internal/mathop";
export function mul(...args) {
    return __mathop(mul, (acc, x) => acc * x, 1, args);
}
